import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {formatCurrency} from "@angular/common";

const CURRENCIES = {
  USD: {
    locale: 'en',
    currency: '$'
  },
  MXN: {
    locale: 'es-MX',
    currency: '$'
  }
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  activeCurrencyKey = 'activeCurrency';
  defaultCurrency = 'USD';
  activeCurrency;

  // requestNewLanguage = new BehaviorSubject(null);
  currencyIsUpdated = new BehaviorSubject(null);

  constructor() {}

  setCurrency(currency) {
    const newCurrency = currency ? currency : this.defaultCurrency;
    this.activeCurrency = newCurrency.toUpperCase();
    localStorage.setItem(this.activeCurrencyKey, this.activeCurrency);
    this.currencyIsUpdated.next(Math.random());
  }

  getActiveCurrency() {
    return localStorage.getItem(this.activeCurrencyKey);
  }

  formatCurrency(amount) {
      return formatCurrency(+amount, 'en', '$');
  }

}
